<template>
  <div class="plugin-manage">
    <div class="breadcrumb">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>创造</el-breadcrumb-item>
        <el-breadcrumb-item>插件</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    
    <el-tabs v-model="activeTab" class="plugin-tabs">
      <el-tab-pane label="自定义插件" name="custom">
        <div class="header-actions">
          <el-button type="primary" icon="el-icon-plus">创建插件</el-button>
          <el-button type="primary" plain icon="el-icon-download">导入插件</el-button>
        </div>
        
        <el-table
          :data="customPlugins"
          style="width: 100%"
          empty-text="暂无自定义插件"
        >
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column label="插件名称">
            <template slot-scope="scope">
              <div class="plugin-name-cell">
                <div class="plugin-icon">
                  <i :class="scope.row.icon"></i>
                </div>
                <div class="plugin-info">
                  <div class="plugin-name">{{ scope.row.name }}</div>
                  <div class="plugin-desc">{{ scope.row.description }}</div>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="type" label="类型" width="120"></el-table-column>
          <el-table-column prop="created" label="创建时间" width="180"></el-table-column>
          <el-table-column label="操作" width="200">
            <template slot-scope="scope">
              <el-button size="mini" @click="handleEdit(scope.row)">编辑</el-button>
              <el-button size="mini" type="danger" @click="handleDelete(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
      
      <el-tab-pane label="内置插件" name="builtin">
        <div class="filter-bar">
          <div class="filter-group">
            <el-radio-group v-model="pluginCategory" size="small">
              <el-radio-button label="all">全部</el-radio-button>
              <el-radio-button label="MCP">MCP</el-radio-button>
              <el-radio-button label="basic-tools">基础工具</el-radio-button>
              <el-radio-button label="search-tools">搜索工具</el-radio-button>
              <el-radio-button label="content-tools">内容处理</el-radio-button>
              <el-radio-button label="image-tools">图像工具</el-radio-button>
              <el-radio-button label="life-tools">生活助手</el-radio-button>
            </el-radio-group>
          </div>
          <div class="search-box">
            <el-input
              placeholder="搜索内置插件"
              prefix-icon="el-icon-search"
              v-model="searchText"
              size="small"
            ></el-input>
          </div>
        </div>
        
        <el-row :gutter="20">
          <el-col :span="8" v-for="(plugin, index) in filteredBuiltinPlugins" :key="index" class="plugin-col">
            <el-card shadow="hover" class="plugin-card">
              <div class="plugin-header">
                <div class="plugin-icon-large" :class="plugin.color">
                  <i :class="plugin.icon"></i>
                </div>
                <div class="plugin-info">
                  <div class="plugin-name">{{ plugin.name }}</div>
                  <div class="plugin-meta">{{ plugin.type }}</div>
                </div>
              </div>
              <div class="plugin-desc">{{ plugin.description }}</div>
              <div class="plugin-footer">
                <div class="plugin-tags">
                  <el-tag size="mini" type="info">{{ plugin.category }}</el-tag>
                </div>
                <el-button type="text" size="small" icon="el-icon-document" @click="viewPluginDocs(plugin)">文档</el-button>
              </div>
            </el-card>
          </el-col>
        </el-row>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
export default {
  name: 'PluginManage',
  data() {
    return {
      activeTab: 'builtin',
      pluginCategory: 'all',
      searchText: '',
      customPlugins: [
        {
          id: 1,
          name: 'AI搜索',
          description: 'AI增强搜索插件，展示内容引用来源',
          icon: 'el-icon-search',
          type: '搜索工具',
          created: '2024-05-15 14:30:00'
        },
        {
          id: 2,
          name: '图像识别',
          description: '根据图像输入进行回答',
          icon: 'el-icon-picture',
          type: '图像工具',
          created: '2024-05-10 09:15:00'
        },
        {
          id: 3,
          name: 'GPT-image-1图像生成',
          description: '使用GPT-Image-1模型进行图片生成和修改',
          icon: 'el-icon-picture-outline',
          type: '图像工具',
          created: '2024-05-08 16:45:00'
        }
      ],
      builtinPlugins: [
        {
          id: 1,
          name: '高德地图',
          description: '高德地图官方MCP Server，支持经纬度查询、IP定位、天气查询、周边查询、路线规划等工具。',
          icon: 'el-icon-map-location',
          color: 'blue-bg',
          type: 'MCP生活助手',
          category: 'MCP'
        },
        {
          id: 2,
          name: '百度地图',
          description: '百度地图官方MCP Server，包含地理编码、地点检索、路线规划等工具。',
          icon: 'el-icon-location-outline',
          color: 'red-bg',
          type: 'MCP生活助手',
          category: 'MCP'
        },
        {
          id: 3,
          name: '博客搜索',
          description: '博客搜索工具，涵盖天气、新闻、百科、医疗、火车票、图片等各种领域。',
          icon: 'el-icon-notebook-2',
          color: 'purple-bg',
          type: 'MCP搜索工具',
          category: 'MCP'
        },
        {
          id: 4,
          name: 'AI搜索',
          description: 'AI增强搜索插件，展示内容引用来源',
          icon: 'el-icon-search',
          color: 'cyan-bg',
          type: '搜索工具',
          category: '搜索工具'
        },
        {
          id: 5,
          name: '图像识别',
          description: '根据图像输入进行回答',
          icon: 'el-icon-camera',
          color: 'green-bg',
          type: '图像工具',
          category: '图像工具'
        },
        {
          id: 6,
          name: 'GPT-image-1图像生成',
          description: '使用GPT-Image-1模型进行图片生成和修改',
          icon: 'el-icon-picture-outline-round',
          color: 'indigo-bg',
          type: '图像工具',
          category: '图像工具'
        },
        {
          id: 7,
          name: '内容总结',
          description: '总结文本及公号文章并开启对话，应用、工作流、插件渠道中可使用',
          icon: 'el-icon-reading',
          color: 'orange-bg',
          type: '内容处理',
          category: '内容处理'
        },
        {
          id: 8,
          name: 'Fetch网页内容读取',
          description: '该工具可以根据大型搜索提供的检索结果处理网页内容，将HTML转换为markdown格式。',
          icon: 'el-icon-download',
          color: 'teal-bg',
          type: '内容处理',
          category: '内容处理'
        }
      ]
    };
  },
  computed: {
    filteredBuiltinPlugins() {
      return this.builtinPlugins.filter(plugin => {
        // 分类筛选
        const categoryMatch = this.pluginCategory === 'all' || plugin.category === this.pluginCategory;
        
        // 搜索文本
        const searchMatch = this.searchText === '' || 
          plugin.name.toLowerCase().includes(this.searchText.toLowerCase()) || 
          plugin.description.toLowerCase().includes(this.searchText.toLowerCase());
        
        return categoryMatch && searchMatch;
      });
    }
  },
  methods: {
    handleEdit(row) {
      this.$message.success(`编辑插件: ${row.name}`);
    },
    handleDelete(row) {
      this.$confirm(`确认删除插件 ${row.name}?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.customPlugins = this.customPlugins.filter(item => item.id !== row.id);
        this.$message.success('删除成功');
      }).catch(() => {
        this.$message.info('已取消删除');
      });
    },
    viewPluginDocs(plugin) {
      this.$message.info(`查看插件文档: ${plugin.name}`);
    }
  }
};
</script>

<style scoped>
.plugin-manage {
  padding-bottom: 50px;
}

.breadcrumb {
  margin-bottom: 20px;
}

.plugin-tabs {
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
  padding: 20px;
}

.header-actions {
  margin-bottom: 20px;
  display: flex;
  gap: 10px;
}

.filter-bar {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}

.search-box {
  width: 240px;
}

.plugin-col {
  margin-bottom: 20px;
}

.plugin-card {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.plugin-header {
  display: flex;
  margin-bottom: 15px;
}

.plugin-icon {
  width: 40px;
  height: 40px;
  background-color: #f5f7fa;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  color: #409EFF;
  margin-right: 10px;
}

.plugin-icon-large {
  width: 50px;
  height: 50px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  color: #fff;
  margin-right: 10px;
}

.blue-bg { background-color: #409EFF; }
.red-bg { background-color: #F56C6C; }
.green-bg { background-color: #67C23A; }
.orange-bg { background-color: #E6A23C; }
.purple-bg { background-color: #9C27B0; }
.cyan-bg { background-color: #00BCD4; }
.teal-bg { background-color: #009688; }
.indigo-bg { background-color: #3F51B5; }

.plugin-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.plugin-name {
  font-weight: 600;
  font-size: 16px;
  color: #303133;
  margin-bottom: 4px;
}

.plugin-meta {
  font-size: 12px;
  color: #909399;
}

.plugin-desc {
  color: #606266;
  font-size: 13px;
  line-height: 1.6;
  margin-bottom: 15px;
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.plugin-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.plugin-tags {
  display: flex;
}

.plugin-name-cell {
  display: flex;
  align-items: center;
}
</style> 